module.exports = __webpack_public_path__ + "static/media/552GriffinStNW_2018-06-05_20.7e5e0e96.jpg";